'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import styled from 'styled-components';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { InfoIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error appActions not yet typed
import { TEST_MODAL_TYPES, NO_TEST_ACCESS, SMART_CONTENT } from 'ContentEditorUI/lib/modalConstants';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { openModal as openModalAppAction, setTestType as setTestTypeAppAction } from 'ContentEditorUI/redux/actions/appActions';
import { closePatagoniaSidebar as closePatagoniaSidebarPanelAction } from 'ContentEditorUI/redux/actions/panelActions';
import { getIsGenerativeAiEnabled } from 'ContentEditorUI/redux/selectors/contentAssistantSelectors';
import { getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getMABCreatableMap, getIsAnyTestRunning } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getActiveStagingDomain } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getPortalHasABTesting } from 'ContentEditorUI/redux/selectors/portalSelectors';
import { getPortalScopesRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { requestUninitialized, requestStarted, requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import { Map as ImmutableMap } from 'immutable';
import { getIsUngatedForAiAbLandingPages } from '../redux/selectors/authSelectors';
import { getIsUsingPersonalization, getContentModelPersonalizationStrategyId } from '../redux/selectors/pageContentModelSelectors';
import { RunATestOption, RunATestDisabledTooltip } from '../components/RunATestOption';
import { getManagePersonalizationVariantsUrl } from '../utils/PersonalizationVariantsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AbTestPql = () => {
  const {
    openUpgradeModal: openABTestUpgradeModal
  } = useUpgradeModal('landing-pages-ab-testing-editor');
  return /*#__PURE__*/_jsx(RunATestOption, {
    dataTestId: "run-a-test__ab--pql",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "consolidatedRunTestEntryPoints.ab.description"
    }),
    isOptionDisabled: false,
    onClick: openABTestUpgradeModal,
    title: /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "mab.buttons.ab.header"
      }), /*#__PURE__*/_jsx(LockBadge, {
        size: "200"
      })]
    })
  });
};
const MabTestPql = () => {
  const {
    openUpgradeModal: openAdaptiveTestUpgradeModal
  } = useUpgradeModal('landing-pages-adaptive-testing-editor-content-hub');
  return /*#__PURE__*/_jsx(RunATestOption, {
    dataTestId: "run-a-test__mab--pql",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "consolidatedRunTestEntryPoints.mab.description"
    }),
    isOptionDisabled: false,
    onClick: openAdaptiveTestUpgradeModal,
    title: /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.title"
      }), /*#__PURE__*/_jsx(LockBadge, {
        size: "200"
      })]
    })
  });
};
const mapStateToProps = state => ({
  isStagedContent: Boolean(getActiveStagingDomain(state)),
  portalHasABTesting: getPortalHasABTesting(state),
  portalScopesRequest: getPortalScopesRequest(state),
  mabCreatableMap: getMABCreatableMap(state),
  isAnyTestRunning: getIsAnyTestRunning(state),
  isLandingPage: getIsLandingPage(state),
  isUngatedForAiAbLandingPages: getIsUngatedForAiAbLandingPages(state),
  isGenerativeAiEnabled: getIsGenerativeAiEnabled(state),
  isUsingPersonalization: getIsUsingPersonalization(state),
  personalizationStrategyId: getContentModelPersonalizationStrategyId(state)
});
const mapDispatchToProps = {
  openModal: openModalAppAction,
  setTestType: setTestTypeAppAction,
  closePatagoniaSidebar: closePatagoniaSidebarPanelAction
};
const AIBadgeWrapper = styled.div.withConfig({
  displayName: "PatagoniaRunATestWrapper__AIBadgeWrapper",
  componentId: "sc-1wbcgsk-0"
})([".ai-icon{width:auto !important;}"]);
class PatagoniaRunATestWrapper extends Component {
  constructor(...args) {
    super(...args);
    this.renderRunAiAbTestOption = () => {
      const {
        openModal,
        setTestType,
        portalScopesRequest,
        portalHasABTesting,
        isAnyTestRunning,
        isGenerativeAiEnabled,
        closePatagoniaSidebar,
        isUsingPersonalization,
        personalizationStrategyId
      } = this.props;
      const isMissingAbTesting = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
      if (isMissingAbTesting) {
        // TODO: Add pql for AiAb -- might need two, one for A/B and one for Breeze / Ai A/B?
        return null;
      }
      const isOptionDisabled = isAnyTestRunning || !isGenerativeAiEnabled || isUsingPersonalization;
      return /*#__PURE__*/_jsx(RunATestOption, {
        dataTestId: "run-a-test__aiab",
        disabledToolTip: /*#__PURE__*/_jsx(RunATestDisabledTooltip, {
          isAnyTestRunning: isAnyTestRunning,
          isUsingPersonalization: isUsingPersonalization,
          isDependentOnGenerativeAi: true,
          isGenerativeAiEnabled: isGenerativeAiEnabled,
          personalizationStrategyId: personalizationStrategyId
        }),
        isOptionDisabled: isOptionDisabled,
        onClick: () => {
          UsageTracker.trackEditorInteraction({
            action: 'Navigation Action',
            event: 'run-a-test-ai-ab'
          });
          closePatagoniaSidebar();
          openModal(TEST_MODAL_TYPES.AI_AB_TEST);
          // openRunTestModal is a prop passed down from parent container that sets testType as a side-effect, while openModal does not.
          // Calling setTestType here, too, to ensure openTestType is set to 'aiab' to keep that consistent.
          setTestType(TEST_MODAL_TYPES.AI_AB_TEST);
        },
        title: /*#__PURE__*/_jsxs(TFlex, {
          direction: "row",
          justify: "between",
          children: [/*#__PURE__*/_jsxs(TFlex, {
            direction: "row",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "consolidatedRunTestEntryPoints.aiab.title"
            }), /*#__PURE__*/_jsx(HelpIcon, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "consolidatedRunTestEntryPoints.aiab.legalDisclaimer"
              }),
              marginInlineStart: "200"
            })]
          }), /*#__PURE__*/_jsx(AIBadgeWrapper, {
            children: /*#__PURE__*/_jsx(AIBadge, {})
          })]
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "consolidatedRunTestEntryPoints.aiab.description"
        })
      });
    };
  }
  renderInfoToolTip() {
    const {
      isAnyTestRunning
    } = this.props;
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
      }),
      placement: "right",
      children: isAnyTestRunning && /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      })
    });
  }
  renderRunAbTestOption(shouldShowAiAbEntryPoint) {
    const {
      portalScopesRequest,
      portalHasABTesting,
      openRunTestModal,
      isAnyTestRunning,
      isUsingPersonalization,
      personalizationStrategyId
    } = this.props;
    const showPql = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
    if (showPql) {
      return /*#__PURE__*/_jsx(AbTestPql, {});
    }
    const isOptionDisabled = isAnyTestRunning || isUsingPersonalization;
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__ab",
      disabledToolTip: /*#__PURE__*/_jsx(RunATestDisabledTooltip, {
        isAnyTestRunning: isAnyTestRunning,
        isUsingPersonalization: isUsingPersonalization,
        personalizationStrategyId: personalizationStrategyId
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.ab.description"
      }),
      isOptionDisabled: isOptionDisabled,
      onClick: () => {
        openRunTestModal(TEST_MODAL_TYPES.AB_TEST);
      },
      title: shouldShowAiAbEntryPoint ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.ab.title"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "mab.buttons.ab.header"
      })
    });
  }
  renderMAbTestOption() {
    const {
      mabCreatableMap,
      portalScopesRequest,
      openRunTestModal,
      isAnyTestRunning,
      isUsingPersonalization,
      personalizationStrategyId
    } = this.props;
    const showMABPQL = mabCreatableMap.get('disabled') && mabCreatableMap.get('reason') === NO_TEST_ACCESS && requestSucceeded(portalScopesRequest);
    const isMabDisabledDueToSmartContent = mabCreatableMap.get('disabled') && mabCreatableMap.get('reason') === SMART_CONTENT;
    if (showMABPQL) {
      return /*#__PURE__*/_jsx(MabTestPql, {});
    }
    const isOptionDisabled = isAnyTestRunning || isUsingPersonalization || isMabDisabledDueToSmartContent;
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__mab",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.description"
      }),
      isOptionDisabled: isOptionDisabled,
      disabledToolTip: /*#__PURE__*/_jsx(RunATestDisabledTooltip, {
        isAnyTestRunning: isAnyTestRunning,
        isUsingPersonalization: isUsingPersonalization,
        isDisabledDueToSmartContent: isMabDisabledDueToSmartContent,
        personalizationStrategyId: personalizationStrategyId
      }),
      onClick: () => {
        openRunTestModal(TEST_MODAL_TYPES.MAB_TEST);
      },
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.title"
      })
    });
  }
  renderRunTestOptions() {
    const {
      isUngatedForAiAbLandingPages,
      isLandingPage,
      isUsingPersonalization,
      isStagedContent,
      personalizationStrategyId
    } = this.props;
    const shouldShowAiAbEntryPoint = isUngatedForAiAbLandingPages && isLandingPage;

    // Do not show PQL or create test button for staged content or if this page is already part of
    // a test (maybe when the user/account downgraded and no longer has the test scope)
    // Brought over from legacy code -- maybe we want to show a message here?
    if (isStagedContent) {
      return null;
    }
    return /*#__PURE__*/_jsxs(List, {
      children: [shouldShowAiAbEntryPoint && this.renderRunAiAbTestOption(), this.renderRunAbTestOption(shouldShowAiAbEntryPoint), this.renderMAbTestOption(), isUsingPersonalization && /*#__PURE__*/_jsx(Text, {
        as: "p",
        paddingInline: "400",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link
          },
          message: "consolidatedRunTestEntryPoints.disabledDueToPersonalization_jsx",
          options: {
            external: true,
            href: getManagePersonalizationVariantsUrl(personalizationStrategyId)
          }
        })
      })]
    });
  }
  render() {
    const {
      portalScopesRequest
    } = this.props;
    if (requestStarted(portalScopesRequest) || requestUninitialized(portalScopesRequest)) {
      return null;
    }
    return this.renderRunTestOptions();
  }
}
PatagoniaRunATestWrapper.propTypes = {
  isStagedContent: PropTypes.bool.isRequired,
  portalHasABTesting: PropTypes.bool.isRequired,
  portalScopesRequest: PropTypes.object.isRequired,
  openRunTestModal: PropTypes.func.isRequired,
  mabCreatableMap: PropTypes.instanceOf(ImmutableMap),
  isAnyTestRunning: PropTypes.bool.isRequired,
  isLandingPage: PropTypes.bool.isRequired,
  isUngatedForAiAbLandingPages: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  isGenerativeAiEnabled: PropTypes.bool.isRequired,
  setTestType: PropTypes.func.isRequired,
  closePatagoniaSidebar: PropTypes.func.isRequired,
  isUsingPersonalization: PropTypes.bool.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(PatagoniaRunATestWrapper);